export const initHamburgerMenu = () => {
  const hamburgerButtonWrap = document.querySelector('.hamburger-button-wrap');
  const header = document.querySelector('#header');

  if (!hamburgerButtonWrap || !header) return;

  // ハンバーガーメニューの開閉処理
  hamburgerButtonWrap.addEventListener('click', () => {
    header.classList.toggle('is-active');
    document.body.style.overflow = document.body.style.overflow === 'hidden' ? 'auto' : 'hidden';
  });

  // 画面幅が768px以上になったらハンバーガーメニューをリセット
  const resetMenuOnResize = () => {
    if (window.innerWidth >= 768) {
      header.classList.remove('is-active');
      document.body.style.overflow = 'auto';
    }
  };
  window.addEventListener('resize', resetMenuOnResize);

  // SP用アコーディオンメニュー（768px未満時）
  const initAccordionInHamburger = () => {
    const triggers = document.querySelectorAll('.js-menu-sp');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        // PCサイズでは動作させない
        if (window.innerWidth >= 768) return;

        e.preventDefault();

        const content = trigger.nextElementSibling;

        if (!content || !content.classList.contains('accordion-content')) return;

        // 他のアコーディオンを閉じる
        document.querySelectorAll('.accordion-content.is-open').forEach(openContent => {
          if (openContent !== content) {
            openContent.classList.remove('is-open');

            const otherTrigger = openContent.previousElementSibling;
            if (otherTrigger && otherTrigger.classList.contains('js-menu-sp')) {
              otherTrigger.classList.remove('-active');
            }
          }
        });

        // 表示トグル
        const isNowOpen = content.classList.toggle('is-open');

        if (isNowOpen) {
          trigger.classList.add('-active');
        } else {
          trigger.classList.remove('-active');
        }
      });
    });
  };

  initAccordionInHamburger();

  // タブレット用のタッチイベント（768px以上でタッチデバイス）
  const initTabletTouchMenu = () => {
    const parentItems = document.querySelectorAll('.g-nav .item.-parent');

    parentItems.forEach(item => {
      const trigger = item.querySelector('.parent-element');
      const content = item.querySelector('.accordion-content');

      if (!trigger || !content) return;

      // タッチイベントリスナー
      trigger.addEventListener('touchend', (e) => {
        // PC以上のサイズでタッチデバイスの場合のみ動作
        if (window.innerWidth < 768) return;

        e.preventDefault();
        e.stopPropagation();

        // 他のアクティブな項目を閉じる
        document.querySelectorAll('.g-nav .item.-parent').forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('is-touch-active');
          }
        });

        // 現在の項目をトグル
        item.classList.toggle('is-touch-active');
      });
    });

    // 外側をタッチした時にメニューを閉じる
    document.addEventListener('touchend', (e) => {
      if (window.innerWidth < 768) return;

      if (!e.target.closest('.g-nav .item.-parent')) {
        document.querySelectorAll('.g-nav .item.-parent').forEach(item => {
          item.classList.remove('is-touch-active');
        });
      }
    });
  };

  initTabletTouchMenu();
};
